import type { FC } from "react"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import { SALES_ORDER_DOCUMENT_TYPE_OPTIONS } from "@/screens/CustomerOrders/constants"

interface UploadSalesOrderDocumentDialogProps {
  onClose: () => void
  onSuccess: () => void
  salesOrderId: string
}

export const UploadSalesOrderDocumentDialog: FC<UploadSalesOrderDocumentDialogProps> = ({
  onClose,
  onSuccess,
  salesOrderId,
}) => (
  <AttachFilesDialog
    title='Upload Document'
    referenceTableName={ReferenceTableName.SalesOrder}
    referenceId={salesOrderId}
    documentTypeOptions={SALES_ORDER_DOCUMENT_TYPE_OPTIONS}
    successMessage='Sales Order documents uploaded'
    testIdPrefix='sales-order.upload-dialog'
    dialogTestId='sales-order.upload-dialog'
    onClose={onClose}
    onSuccess={onSuccess}
  />
)
